// Simple Zustand store for portfolio state
import { create } from 'zustand';

export const usePortfolioStore = create((set, get) => ({
  initiatives: [],
  filterType: 'all',
  searchTerm: '',
  setInitiatives: (list) => set({ initiatives: Array.isArray(list) ? list : [] }),
  setFilter: (t) => set({ filterType: t || 'all' }),
  setSearch: (q) => set({ searchTerm: (q || '').toLowerCase() }),
}));

// Non-hook helpers for non-Preact code
export const portfolioStore = {
  setInitiatives: (list) => usePortfolioStore.getState().setInitiatives(list),
  getInitiatives: () => usePortfolioStore.getState().initiatives,
};

